export default "__VITE_ASSET__BwSX1QeM__"